import { actionNotifier } from "../components/ui/toast";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ReportIcon from "@mui/icons-material/Report";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const getReason = (status) => {
    const reasons = status?.slice()?.reverse()?.find((s, i) => s?.status === "CANCELLED_BY_STUDENT" || s?.status === "RESCHEDULED_BY_STUDENT" || s?.status === "RESCHEDULED_BY_COUNSELOR")
    // const reasons = status?.slice()?.reverse()?.find((s, i) => s?.status === activeTab)
    return reasons ? reasons?.extra?.reason : null
}

export const camelToSentenceCase = (str) => {
    const result = str.replaceAll(/([a-z])([A-Z])/g, "$1 $2");
    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    return finalResult;
};

export const convertToTitleCase = (str) => {
    return str
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

export const convertSnakeCaseToUpperCase = (str) => {
    return str
        .split('_')
        .join(' ')
        .toUpperCase();
};

export const getMeetingTime = (data) => {
    const lastUpdatedMeeting = data?.slice()?.reverse()?.find((s, i) => s?.status === "UPDATED")
    // const lastUpdatedMeeting = false
    const appliedMeeting = data?.slice()?.reverse()?.find((s, i) => s?.status === "APPLIED")

    return lastUpdatedMeeting?.extra?.onDateTime
        ? { time: lastUpdatedMeeting?.extra?.onDateTime, type: "U" }
        : { time: appliedMeeting?.extra?.onDateTime, type: "A" };
};

export const throwError = (error, msg) => {
    if (error?.data?.statusCode === 400) {
        actionNotifier.error(`${error.data.message}`)
    } else if (error?.message) {
        actionNotifier.error(`${error?.message}`)
    } else {
        actionNotifier.error(`${msg}`)
    }
};

export const calculateEndDate = (createdAt, monthsToAdd) => {
    const createdDate = new Date(createdAt);
    createdDate.setMonth(createdDate.getMonth() + parseInt(monthsToAdd));
    return createdDate.toISOString();
};

export const convertAvailability = (data) => {
    const dayMapping = {
        "Sun": 0,
        "Mon": 1,
        "Tue": 2,
        "Wed": 3,
        "Thu": 4,
        "Fri": 5,
        "Sat": 6
    };

    const timings = Object.entries(data.weekwise).flatMap(([day, slots]) =>
        slots.filter(slot => slot.timeFrom && slot.timeTo).map(slot => ({
            day: dayMapping[day],
            startTime: slot.timeFrom,
            endTime: slot.timeTo
        }))
    );

    return {
        year: new Date(data.startTime).getUTCFullYear(),
        month: new Date(data.startTime).getUTCMonth(),
        timings
    };
};

export const getStatusComponent = (status, ColumnsData) => {
    const statusItem = ColumnsData.councellingStatusTabs.find(
        (item) => item.value === status
    );

    if (!statusItem) return null;

    return (
        <span style={{ display: 'flex', alignItems: 'center', gap: 6, color: statusItem.color }}>
            {statusItem.icon}
            <span>{statusItem.label}</span>
        </span>
    );
};
export const isWithinSessionWindow = (onDateTime) => {
    if (!onDateTime) return false;
    // Use current time plus the 5.5 hour IST offset to match 
    // how the backend timestamps are being handled/displayed.
    const nowUTC = new Date();
    const IST_OFFSET = 5.5 * 60 * 60 * 1000;
    const nowIST = new Date(nowUTC.getTime() + IST_OFFSET);
    const sessionTime = new Date(onDateTime);
    const diffInMin = (sessionTime - nowIST) / (1000 * 60);

    // From 120 mins after to 10 mins before
    return diffInMin >= -120 && diffInMin <= 10;
};

export const isWithinRescheduleWindow = (onDateTime) => {
    if (!onDateTime) return false;
    // Use current time plus the 5.5 hour IST offset to match 
    // how the backend timestamps are being handled/displayed.
    const nowUTC = new Date();
    const IST_OFFSET = 5.5 * 60 * 60 * 1000;
    const nowIST = new Date(nowUTC.getTime() + IST_OFFSET);
    const sessionTime = new Date(onDateTime);
    const diffInMin = (sessionTime - nowIST) / (1000 * 60);

    // Active for 12 hours (720 minutes) around the session time
    return diffInMin >= -720 && diffInMin <= 720;
};


export const renderAuditIcon = (auditted, autoAuditted) => {
    if (autoAuditted) return <CheckCircleIcon color="success" />;
    if (auditted) return <ReportIcon color="warning" />;
    return <CancelIcon color="error" />;
};
